export function LocalServer() {
    return 'https://api.sevanasahayi.com/';
    // return 'http://127.0.0.1:8001/';

}